import { jsx as _jsx } from "react/jsx-runtime";
import { generateUuid } from '@zurich-framework/core/utils';
import { createContext, useContext, useMemo, } from 'react';
import { BusinessProcessIdProvider, ConfigProvider, FetchApiProvider, } from '@zurich/common/contexts';
import { SnackbarError } from '../components';
function createAppInstanceContext() {
    return createContext(null);
}
export const AppInstanceContext = createAppInstanceContext();
export function AppInstanceProvider({ appInstance, config, businessProcessId, children, }) {
    const bpid = useMemo(() => businessProcessId ?? generateUuid(), [businessProcessId]);
    return (_jsx(AppInstanceContext.Provider, { value: appInstance, children: _jsx(ConfigProvider, { config: config, children: _jsx(BusinessProcessIdProvider, { businessProcessId: bpid, children: _jsx(FetchApiProvider, { SnackbarError: SnackbarError, children: children }) }) }) }));
}
export function useAppInstanceContext() {
    const appInstance = useContext(AppInstanceContext);
    if (!appInstance) {
        throw 'AppInstance used without AppInstanceProvider!';
    }
    return appInstance;
}
